<template>
    <div>
    <a-row :gutter="[48,0]">
    <a-col :span="8">
        <a-row :gutter="[0,24]">
        <a-col :span="8" class="param-text">
            Group1:
        </a-col>
        <a-col :span="16">
            <a-select v-model="group1" placeholder="Select group1" style="width: 100%;" :options="groupList" @change="handleGroupChange1">
            </a-select>
        </a-col>
        </a-row>
        
        <a-row :gutter="[0,24]">
        <a-col :span="8" class="param-text">
            Group2:
        </a-col>
        <a-col :span="16">
            <a-select v-model="group2" placeholder="Select group2" style="width: 100%;" :options="groupList" @change="handleGroupChange2">
            </a-select>
        </a-col>
    </a-row>
    
    <a-row :gutter="[0,24]">
        <a-col :span="8" class="param-text">
            P Cutoff:
        </a-col>
        <a-col :span="11">
            <a-slider v-model="PCutOff" :min="0" :max="0.1" :step="0.01" style="margin-top:11px;" />
        </a-col>
        <a-col :span="5">
            <a-input-number v-model="PCutOff" :min="0" :max="1" :step="0.01" style="width: 100%;" />
        </a-col>
    </a-row>
    
    <a-row :gutter="[0,24]">
        <a-col :span="8" class="param-text">
            LogFC Cutoff:
        </a-col>
        <a-col :span="11">
            <a-slider v-model="LogFCCutOff" :min="0" :max="10" :step="0.01" style="margin-top:11px;"/>
        </a-col>
        <a-col :span="5">
            <a-input-number
            v-model="LogFCCutOff"
            :min="0"
            :max="10"
            :step="0.01"
            style="width: 100%;"
            />
        </a-col>
    </a-row>
    <a-row :gutter="[0,24]">
        <a-col :span="24">
            <a-button @click="handleAnalysis">Start analysis</a-button>
        </a-col>
    </a-row>
    <a-row :gutter="[0,24]">
        <a-col :span="8">
            <a-button icon="download" :loading="loading" @click="handleDownload(mRNA_DEG_Figure1_Url)" style="margin: auto 0;" type="primary">Figure1</a-button>
        </a-col>
        <a-col :span="8">
            <a-button icon="download" :loading="loading" @click="handleDownload(mRNA_DEG_Figure2_Url)" style="margin: auto 0;" type="primary">Figure2</a-button>
        </a-col>
        <a-col :span="8">
            <a-button icon="download" :loading="loading" @click="handleDownload('api/download/' + mRNA_DEG_Table_Url)" style="margin: auto 0;" type="primary">Table</a-button>
        </a-col>
    </a-row>

    </a-col>
    <a-col :span="16">
        <div>
        <a-tabs default-active-key="1" tabPosition="bottom" style="width: 100%;">
            <a-tab-pane key="1" tab="Figure1">
            <div class="content" style="width: 520px;">
                <a-icon v-if="loading" class="placeholder" style="font-size:50px;" type="loading" />
                <custom-pdf v-else-if="mRNA_DEG_Figure1_Url" ref="pdf1Component" :src="mRNA_DEG_Figure1_Url"/>
                <div v-else class="placeholder">Failed, please retry.</div>
            </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="Figure2">
            <div class="content" style="width: 693px;">
                <a-icon v-if="loading" class="placeholder" style="font-size:50px;" type="loading" />
                <custom-pdf v-else-if="mRNA_DEG_Figure2_Url" ref="pdf2Component" :src="mRNA_DEG_Figure2_Url"/>
                <div v-else class="placeholder">Failed, please retry.</div>
            </div>
            </a-tab-pane>
            <a-tab-pane key="3" tab="Table">
            <div class="content" style="padding: 10px; width: 100%;">
                <a-icon v-show="loading" class="placeholder" style="font-size:50px;" type="loading" />
                <data-table v-show="!loading" :data="tableData" style="height: 100%;" :scroll-y="450"/>
            </div>
            </a-tab-pane>
        </a-tabs>
        </div>
    </a-col>
    </a-row>
    </div>
</template>
    
<script>
import api from '@/api';
import { downloadFile } from '@/utils';
import XLSX from 'xlsx';
import CustomPdf from '@/components/CustomPdf.vue';
import Papa from 'papaparse';
import DataTable from '@/components/DataTable.vue';
import { v4 as uuidv4 } from 'uuid';

export default {
    // inject: ['uuid'],
    name: 'DifferentialExpression',
components: {
    DataTable,
    CustomPdf
},
    data() {
    return {
    uuid: uuidv4(),
    loading: false,
    group1: 'TNBC_CAP',
    group2: 'TNBC_Control',
    groupList: [
        {value:'TNBC_CAP', label: 'TNBC_CAP'},
        {value:'TNBC_Control', label: 'TNBC_Control'},
        {value:'nonTNBC_CAP', label: 'nonTNBC_CAP'},
    ],
    PCutOff: 0.1,
    LogFCCutOff: 1.2,
    mRNA_DEG_Figure1_Url: 'api/download/output/sample/lac/Differential.modification.site.heatmap.pdf',
    mRNA_DEG_Figure2_Url: 'api/download/output/sample/lac/Differential.modification.site.volcano.pdf',
    mRNA_DEG_Table_Url: 'output/sample/lac/Differential.modification.site.xlsx',
    tableData: []   // 表格数据
    };
},
created() {
    this.loadTableDataXlsx(this.mRNA_DEG_Table_Url)
},
    methods: {
    handleDownload(url) {
      downloadFile(url);
    },
    onPdf1Loaded() {
        // this.$nextTick(() => {
        //   const canvas = this.$refs.pdf1Component.$el.querySelector('canvas');
        //   if (canvas) {
        //     setTimeout(() => {
        //       const actualWidth = canvas.width; 
        //       const actualHeight = canvas.height; 
        //       const aspectRatio = actualWidth / actualHeight;
        //       this.resizedWidth1 = 480 * aspectRatio;
        //     }, 10);
        //   }
        // });
    },
    onPdf2Loaded() {
        // this.$nextTick(() => {
        //   const canvas = this.$refs.pdf2Component.$el.querySelector('canvas');
        //   if (canvas) {
        //     setTimeout(() => {
        //       const actualWidth = canvas.width; 
        //       const actualHeight = canvas.height; 
        //       const aspectRatio = actualWidth / actualHeight;
        //       this.resizedWidth2 = 480 * aspectRatio;
        //     }, 10);
        //   }
        // });
    },
    handleAnalysis() {
        this.loading = true
        api.post('/analysis/r', {uuid: this.uuid, category: "lac", tool: "Differential_modification", param: {Group1: this.group1, Group2: this.group2, pCutoff: this.PCutOff, fcCutoff: this.LogFCCutOff}})
        .then(response => {
            this.mRNA_DEG_Table_Url = this.findStringsEndingWith(response.data, "Differential.modification.site.xlsx").slice(11) + '?timestamp=' + Date.now()
            this.loadTableDataXlsx(this.mRNA_DEG_Table_Url)
            this.mRNA_DEG_Figure1_Url = "api/download/" + this.findStringsEndingWith(response.data, "Differential.modification.site.heatmap.pdf").slice(11) + '?timestamp=' + Date.now()
            this.mRNA_DEG_Figure2_Url = "api/download/" + this.findStringsEndingWith(response.data, "Differential.modification.site.volcano.pdf").slice(11) + '?timestamp=' + Date.now()
            this.loading = false
        })
        .catch(error => {
            console.error('Error occurred:', error);
            this.mRNA_DEG_Figure1_Url = ""
            this.mRNA_DEG_Figure2_Url = ""
            this.Table_Url = []
            this.loading = false
            // 在这里处理请求错误
        });
        },
    // 加载并解析XLSX文件
    loadTableDataXlsx(mRNA_DEG_Table_Url) {
        api.get('/download/' + mRNA_DEG_Table_Url, { responseType: 'arraybuffer' })
        .then(response => {
        const data = new Uint8Array(response);
        const workbook = XLSX.read(data, { type: 'array' });

        // 假设要读取第一个工作表
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // XLSX.utils.sheet_to_json 返回一个对象数组，与PapaParse的输出类似
        this.tableData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (this.tableData.length > 0) {
            // 提取表头
            const headers = this.tableData[0];
            // 使用表头创建每行的数据对象
            this.tableData = this.tableData.slice(1).map(row => {
            return headers.reduce((obj, header, index) => {
                obj[header] = row[index];
                return obj;
            }, {});
            });
        }
        })
        .catch(error => {
        console.error('获取XLSX文件出错:', error);
        });
    },
    // 加载并解析CSV文件
    loadTableDataCsv(mRNA_DEG_Table_Url) {
        api.get(/download/ + mRNA_DEG_Table_Url)
        .then(response => {
            Papa.parse(response, {
            header: true, // 第一行作为表头
            skipEmptyLines: true,
            complete: results => {
                this.tableData = results.data;
            },
            error: (error) => {
                console.error('CSV解析错误:', error);
            }
            });
        })
        .catch(error => {
            console.error('获取CSV文件出错:', error);
        });
    },
    findStringsEndingWith(stringsArray, ending) {
        const foundString = stringsArray.find(str => str.endsWith(ending));
        return foundString || '';
    },
    handleGroupChange1() {
        if (this.group1 !== 'TNBC_CAP') {
            this.group2 = 'TNBC_CAP'
        }
    },
    handleGroupChange2() {
        if (this.group2 !== 'TNBC_CAP') {
            this.group1 = 'TNBC_CAP'
        }
    }
    },
};
</script>

<style scoped>
.content {
height: 520px; /* 占据空间 */
}
.placeholder {
min-height: 480px;
display: flex;
justify-content: center;
align-items: center;
color: #999;
}

.param-text {
font-size: 14px;
font-weight: 600;
margin-top: 5px;
}
</style>

<style>
.parent-tabs > .ant-tabs-bar .ant-tabs-tab {
font-size: 16px !important; /* 增大字体 */
background-color: #f0f2f5 !important; /* 未选中标签的背景色 */
color: #1890ff !important; /* 未选中标签的文字色 */
border: 1px solid #d9d9d9 !important; /* 标签的边框 */
}

.parent-tabs > .ant-tabs-bar .ant-tabs-tab-active {
background-color: #1890ff !important; /* 选中标签的背景色 */
color: #fff !important; /* 选中标签的文字色 */
border-color: #1890ff !important; /* 选中标签的边框色 */
}

.parent-tabs > .ant-tabs-bar .ant-tabs-tab:hover {
color: #40a9ff !important; /* 悬停时的文字色 */
}

.parent-tabs > .ant-tabs-bar .ant-tabs-tab + .ant-tabs-tab {
margin-left: 4px !important; /* 调整标签之间的间距 */
}
</style>